import { ReactNode, useState, useRef, useEffect, CSSProperties } from 'react'

import { Text } from '@hhgtech/hhg-components'

import { getHellositePath } from 'api/utils/paths'
import { Markdown } from 'components/atoms/markdown'
import { useRouterExtend } from 'hooks/useRouterExtend'
import MinusIcon from 'public/svg/minus.svg'
import PlusIcon from 'public/svg/plus.svg'

import {
  StyledHeading,
  StyledExpandableContainer,
  StyledContentWrapper,
  StyledExpandedCard,
} from './index.styled'

export type Props = {
  title: ReactNode
  contentString?: string
  content?: ReactNode
  isMobile?: boolean
  defaultExpand?: boolean
  className?: string
  iconPosition?: 'left' | 'right'
  style?: CSSProperties
  isExpand?: boolean
  onChange?: any
  dataEventCategory?: string
  dataEventAction?: string
  dataEventLabel?: string
}
const ExpandedCard = ({
  title,
  content,
  contentString,
  isMobile,
  iconPosition,
  className,
  style,
  defaultExpand,
  isExpand,
  onChange,
  dataEventCategory,
  dataEventAction,
  dataEventLabel,
}: Props) => {
  const { locale, router } = useRouterExtend()
  const [expand, setExpand] = useState(isExpand || false)
  const [cHeight, setCHeight] = useState(0)
  const ExpandedCardRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (defaultExpand) {
      setTimeout(() => {
        setExpand(defaultExpand)
      }, 100)
    }
  }, [])

  useEffect(() => {
    setExpand(!!isExpand)
    setCHeight(ExpandedCardRef.current?.clientHeight || 0)
  }, [isExpand])

  return (
    <StyledExpandedCard className={className} style={style}>
      <StyledHeading
        onClick={() => {
          if (!!onChange) {
            onChange(!expand)
          } else {
            setExpand((e) => !e)
          }
        }}
        data-event-category={dataEventCategory || 'Expand Info'}
        data-event-action={dataEventAction || 'Click'}
        data-event-label={
          dataEventLabel ||
          getHellositePath({
            locale,
            slug: router.asPath,
          })
        }
      >
        <div
          style={{
            position: 'absolute',
            right: iconPosition === 'right' ? 0 : 'unset',
            left: iconPosition === 'left' ? 0 : 'unset',
            display: 'flex',
          }}
        >
          {expand ? (
            <MinusIcon width={isMobile ? '16' : '20'} viewBox="0 0 12 3" />
          ) : (
            <PlusIcon width={isMobile ? '16' : '20'} viewBox="0 0 16 16" />
          )}
        </div>
        <div
          style={{
            flex: 1,
            paddingRight: iconPosition === 'right' ? '28px' : '0',
          }}
        >
          {typeof title === 'string' ? (
            <Text size="p2" type={expand ? 'bold' : 'regular'}>
              <Markdown>{title}</Markdown>
            </Text>
          ) : (
            title
          )}
        </div>
      </StyledHeading>
      <StyledExpandableContainer
        data-expand={expand}
        style={
          expand
            ? {
                height: cHeight + 8,
              }
            : {}
        }
      >
        {contentString ? (
          <StyledContentWrapper
            ref={ExpandedCardRef}
            dangerouslySetInnerHTML={{ __html: contentString }}
          />
        ) : null}
        {!contentString && content ? (
          <StyledContentWrapper ref={ExpandedCardRef}>
            {content}
          </StyledContentWrapper>
        ) : null}
      </StyledExpandableContainer>
    </StyledExpandedCard>
  )
}

export { ExpandedCard }
